const data = {
    module_name: "blog",
    title: "Blog",
    key: 'blog',
    category_key: "blog",
    excel_key: "blog"
}

module.exports = data